module.exports = __webpack_public_path__ + "static/change-8b75f858fcdc63eaf51fd49a70dacdd3.gif";